var React = require('react');

function Gn (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt"},[React.createElement("path",{"fill":"red","d":"M0 0h213.3v480H0z","key":0}),React.createElement("path",{"fill":"#ff0","d":"M213.3 0h213.4v480H213.3z","key":1}),React.createElement("path",{"fill":"#090","d":"M426.7 0H640v480H426.7z","key":2})]));
}

Gn.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Gn;

Gn.default = Gn;
